import { useState } from 'react'
import { useForm } from 'react-hook-form'

import {
  If,
  Button,
  Text,
  DsIcon as Icon,
  Input
} from '@itau-loans-www/components'
import { useLead } from '@itau-loans-www/hooks'
import { http, sdkAnalytics } from '@itau-loans-www/services'
import { goTo, formatters } from '@itau-loans-www/utils'

import './simulator-lp.scss'

const Simulator = ({ cta }) => {
  const { number } = formatters

  const {
    leadData: { balance, date, partner }
  } = useLead()

  const initialValues = {
    balance: balance ?? '',
    date: date ?? ''
  }

  const {
    handleSubmit,
    control,
    formState: { isValid }
  } = useForm({
    mode: 'onChange',
    defaultValues: initialValues
  })

  const [isLoading, setIsLoading] = useState(false)
  const [simulationResponse, setSimulationResponse] = useState()

  const onSubmit = async ({ balance, date }) => {
    const requestBody = {
      fgts_balance: number.currencyToFloat(balance),
      birthdate: formatters.date.toISO(date)
    }
    const isPartner = !!partner

    setIsLoading(true)

    return http.fgts
      .postSimulationData(requestBody, isPartner)
      .then((response) => {
        setIsLoading(false)
        setSimulationResponse(response.data)
      })
      .catch(() => setIsLoading(false))
  }

  const FirstStep = () => {
    return (
      <form className="simulation-form" onSubmit={handleSubmit(onSubmit)}>
        <h2 className="simulation-form__title">{cta.title}</h2>
        <Text
          label="Saldo do seu FGTS"
          id="balance"
          mask="currency"
          name="balance"
          rules={{
            isRequired: true,
            isGreaterOrEqualThan: 250
          }}
          withoutAsterisk
          control={control}
        />
        <Input.Birthdate
          label="Data de nascimento"
          name="date"
          control={control}
        />
        <Button
          type="submit"
          data-testid="submit-btn"
          className="simulation-form__button"
          id={cta.id}
          disabled={!isValid || isLoading}
          fluid
        >
          {cta.label}
        </Button>
      </form>
    )
  }

  const SecondStep = () => {
    return (
      <div className="simulation-fgts-response">
        <h1 className="simulation-fgts-response__title">
          Você pode receber agora até:
        </h1>
        <h2 className="simulation-fgts-response__value">
          {number.toCurrency(simulationResponse.available_value)}
        </h2>
        <p className="simulation-fgts-response__tax">
          Taxas de{' '}
          {simulationResponse.interest_rate.toLocaleString('pt-br', {
            style: 'percent',
            minimumFractionDigits: 2
          })}{' '}
          a.m.
        </p>
        <p className="simulation-fgts-response__disclaimer">
          *Valores sujeitos à variação e análise de crédito
        </p>
        <Button
          className="simulation-fgts-btn -back-simulation"
          type="button"
          id="back-fgts-simulation"
          data-testid="back-fgts-simulation"
          onClick={() => {
            setSimulationResponse(undefined)
          }}
          variant="secondary"
        >
          <Icon className="-back-simulation-arrow" name="seta_esquerda" />{' '}
          Voltar
        </Button>
        <Button
          fluid
          type="button"
          id="continue-fgts-simulation"
          data-testid="continue-fgts-simulation"
          onClick={() => {
            sdkAnalytics.track(
              'trackClick',
              'btn:seguir-calculadora-simplificada'
            )
            goTo('basic-data')
          }}
        >
          Contratar agora
        </Button>
      </div>
    )
  }

  return (
    <If
      condition={simulationResponse}
      renderIf={<SecondStep />}
      renderElse={<FirstStep />}
    />
  )
}

export default Simulator
